module.exports = __webpack_public_path__ + "static/media/Global Gaming Survey Report -3.b4e227eb.PNG";